import { render, staticRenderFns } from "./AnalisiRischiViewComponent.vue?vue&type=template&id=144a6410&scoped=true"
import script from "./AnalisiRischiViewComponent.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AnalisiRischiViewComponent.vue?vue&type=style&index=0&id=144a6410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a6410",
  null
  
)

export default component.exports